function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37 16H13C11.895 16 11 16.895 11 18V32C11 33.105 11.895 34 13 34H37C38.105 34 39 33.105 39 32V18C39 16.895 38.105 16 37 16ZM30 20H32V22H30V20ZM26 20H28V22H26V20ZM30 24V26H28V24H30ZM22 20H24V22H22V20ZM26 24V26H24V24H26ZM18 20H20V22H18V20ZM22 24V26H20V24H22ZM14 20H16V22H14V20ZM14 24H18V26H14V24ZM16 30H14V28H16V30ZM32 30H18V28H32V30ZM36 30H34V28H36V30ZM36 26H32V24H36V26ZM36 22H34V20H36V22Z"
});

function SvgIcA8670Ba4675D4712Abe19Ac5Aa398081(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcA8670Ba4675D4712Abe19Ac5Aa398081);
export default ForwardRef;